import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showLoading)
      ? (_openBlock(), _createBlock(_component_a_spin, {
          key: 0,
          tip: "Loading...",
          class: "global-spinner"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ]))
}